import { useState, useEffect } from 'react';
import Item from './item';
import GroupItem from './groupItem';

const ExerciseList = ({
  selectedExercises,
  setSelectedExercises,
  handleDeleteExercise,
  preference,
}) => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleSelectExercise = (index) => {
    setOpenIndex(index);
  };

  return (
    selectedExercises.length > 0 && (
      <div className='mb-6'>
        {selectedExercises.map((exercise, index) =>
          exercise.groupId ? (
            <GroupItem
              key={index}
              index={index}
              exercise={exercise}
              handleSelectExercise={handleSelectExercise}
              handleDeleteExercise={handleDeleteExercise}
              selectedExercises={selectedExercises}
              setSelectedExercises={setSelectedExercises}
              openIndex={openIndex}
              preference={preference}
            />
          ) : (
            <Item
              key={index}
              index={index}
              exercise={exercise}
              handleSelectExercise={handleSelectExercise}
              handleDeleteExercise={handleDeleteExercise}
              selectedExercises={selectedExercises}
              setSelectedExercises={setSelectedExercises}
              openIndex={openIndex}
              preference={preference}
            />
          )
        )}
      </div>
    )
  );
};

export default ExerciseList;
